import React from 'react';
import * as util from '../util';
const AddrLink = ({ addr, text }) => {
  return (
    <a target="_blank" rel="noopener noreferrer" href={util.addrLink(addr)}>
      {text}
    </a>
  );
};
export default AddrLink;
